import { render, staticRenderFns } from "./PdfFieldEditor.vue?vue&type=template&id=12e8c287&scoped=true&"
import script from "./PdfFieldEditor.vue?vue&type=script&lang=js&"
export * from "./PdfFieldEditor.vue?vue&type=script&lang=js&"
import style0 from "./PdfFieldEditor.vue?vue&type=style&index=0&id=12e8c287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8c287",
  null
  
)

export default component.exports